module.exports = __webpack_public_path__ + "img/point-s-white.b0e86941.png";